import { render, staticRenderFns } from "./BotaoTooltipDatatable.vue?vue&type=template&id=31a0d4c6&scoped=true"
import script from "./BotaoTooltipDatatable.vue?vue&type=script&lang=js"
export * from "./BotaoTooltipDatatable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a0d4c6",
  null
  
)

export default component.exports